import { userRepository } from '../repositories/user-repository';

async function deleteAccount() {
    return userRepository.delete();
}

export {
    deleteAccount
};
